module.exports = __webpack_public_path__ + "static/media/PM5.6496a17d.JPG";